// extracted by mini-css-extract-plugin
module.exports = {"container":"Tabs-module--container--MM0Ha"};